import { createContext, useContext } from "react";

import { useLocalStorage } from "./hook";

import { User } from "./user";

type AuthContextResult = {
  user: User;
  setUser: (u: User) => void;
  resetUser: () => void;
};

const useUser = () => {
  const [user, setUser] = useLocalStorage("user", null);

  const resetUser = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("redirectAfterLogin");
    setUser(null);
  };

  return { user, setUser, resetUser };
};

const AuthContext = createContext<AuthContextResult | undefined>(undefined);

type AuthProviderProps = {
  children: React.ReactNode;
};

const AuthProvider = ({ children }: AuthProviderProps) => {
  const userValue = useUser();

  return (
    <AuthContext.Provider value={userValue}>{children}</AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context)
    throw Error("useAuthContext can only be used inside an AuthProvider");
  return context;
};

export { AuthProvider, useAuth };
